// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3119) return "static/chunks/3119-676163be66f66ea1.js";
	if (chunkId === 3859) return "static/chunks/3859-cff1cb2316964ed4.js";
	if (chunkId === 9617) return "static/chunks/9617-ec3dd729e8fe9481.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2443":"1d448cad90a5e7b3","2823":"9336df1c6958b36a","4654":"0a485500d680da57","5192":"ac3e4df86f97893e","5355":"912eb1a062a2681e","8395":"4cca90e54b5723de","9595":"69070d76923f98f7","9718":"4396138145d9ca31"}[chunkId] + ".js";
};